import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as SiteActions from './site.actions';
import { Deserialize, Serialize } from 'cerialize';
import {
  Site,
} from '../../models/site';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { ColorTools } from '../../tools/color.tools';
import { SiteUserSettings } from '../../models/site-user-settings';


@Injectable()
export class SiteEffects {

  loadSites$ = createEffect(() => {
    return this.actions$.pipe(ofType(SiteActions.loadSites),
      concatMap(({organizationId}) =>
      this.api.sites$(organizationId).pipe(
        map(sites => sites.map((site: any) =>  Deserialize(site, Site))),
        map(sites => ColorTools.setColorsForSites(sites)),
        map(sites => SiteActions.loadSitesSuccess({ sites })),
        catchError(error => of(SiteActions.loadSitesFailure({ error }))))
    ));
  });

  retrieveSite$ = createEffect(() => {
    return this.actions$.pipe(ofType(SiteActions.retrieveSite),
      concatMap(({organizationId, siteId}) =>
        this.api.site$(organizationId, siteId).pipe(
          map(site => ColorTools.setColorsForSite(Deserialize(site, Site))),
          map(site => {
            return {id: site.id, changes: site};
          }),
          map(update => SiteActions.retrieveSiteSuccess({ update })),
          catchError(error => of(SiteActions.retrieveSiteFailure({ error }))))
      ));
  });

  activateSite$ = createEffect(() => {
    return this.actions$.pipe(ofType(SiteActions.activateAdvancedFeatures),
      concatMap(({organizationId, siteId}) =>
        this.api.activateSite$(organizationId, siteId).pipe(
          map(site => ColorTools.setColorsForSite(Deserialize(site, Site))),
          map(site => {
            return {id: site.id, changes: site};
          }),
          map(update => SiteActions.activateAdvancedFeaturesSuccess({ update })),
          catchError(error => of(SiteActions.activateAdvancedFeaturesFailure({ error }))))
      ));
  });

  deactivateSite$ = createEffect(() => {
    return this.actions$.pipe(ofType(SiteActions.deactivateAdvancedFeatures),
      concatMap(({organizationId, siteId}) =>
        this.api.deactivateSite$(organizationId, siteId).pipe(
          map(site => ColorTools.setColorsForSite(Deserialize(site, Site))),
          map(site => {
            return {id: site.id, changes: site};
          }),
          map(update => SiteActions.deactivateAdvancedFeaturesSuccess({ update })),
          catchError(error => of(SiteActions.deactivateAdvancedFeaturesFailure({ error }))))
      ));
  });

  loadUserSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SiteActions.loadUserSettings),
      concatMap(({organizationId, siteId}) =>
        this.api.siteUserSettings$(organizationId, siteId).pipe(
          map(settings => Deserialize(settings, SiteUserSettings)),
          map(settings =>
            SiteActions.loadUserSettingsSuccess({settings})
          ),
          catchError(error =>
            of(SiteActions.loadUserSettingsFailure({error}))
          )
        )
      )
    );
  });


  updateUserSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SiteActions.updateUserSettings),
      concatMap(({organizationId, siteId, settings}) =>
        this.api.updateSiteUserSettings$(
          organizationId,
          siteId,
          Serialize(settings),
        ).pipe(
          map(settings => Deserialize(settings, SiteUserSettings)),
          map(settings =>
            SiteActions.updateUserSettingsSuccess({settings})
          ),
          catchError(error =>
            of(SiteActions.updateUserSettingsFailure({error}))
          )
        )
      )
    );
  });

  constructor(private actions$: Actions, private store: Store, private api: ApiService) {}

}
